import React from "react";

// components
import Header from "../../components/template/header/Header";

const MainView = (props) => {
  const { children } = props;

  return (
    <main>
      <Header />
      <div>{children}</div>
    </main>
  );
};

export default MainView;
